<div class="leftinnerdiv" *ngIf="lender_application_complete == 0">
  <div class="row mainprogdiv">
    <ul class="progress2 vertical">
      <li class="success" [routerLink]="['/invest/pan-verification']">
        <p class="psuccesstxt">PAN verification</p>
        <p class="pactivetxt2">So that we can identify you</p>
      </li>
      <li class="success" [routerLink]="['/invest/phone-verification']">
        <p class="psuccesstxt">Mobile verification</p>
        <p class="pactivetxt2">To help us reach you</p>
      </li>
      <li class="success" [routerLink]="['/invest/email-verification']">
        <p class="psuccesstxt">Email verification</p>
        <p class="pactivetxt2">To help us reach you</p>
      </li>
      <li class="active">
        <p class="pactivetxt1">Personal Information</p>
        <p class="pactivetxt2">It’s important for us to know you</p>
      </li>
      <li>
        <p class="ptxt1">Proof of residence</p>
        <p class="ptxt2">To stay connected through a verified address</p>
      </li>
      <li>
        <p class="ptxt1">Bank details</p>
        <p class="ptxt2">To enable us send returns on your investment</p>
      </li>
      <li>
        <p class="ptxt1">Nominee Details</p>
        <p class="ptxt2">Add a nominee for your investments</p>
      </li>
      <li>
        <p class="ptxt1">Investment Preferences</p>
        <p class="ptxt2">Set your investment preferences to choose how your investments are allocated to loans</p>
      </li>
      <li>
        <p class="ptxt1">Upload Documents</p>
        <p class="ptxt2">To enable us to put your investments to work quicker</p>
      </li>
    </ul>
  </div>
</div>

<div class="leftinnerdiv" *ngIf="lender_application_complete == 33">
  <div class="row mainprogdiv">
    <ul class="progress2 vertical">
      <li class="success" [routerLink]="['/invest/pan-verification']">
        <p class="psuccesstxt">PAN verification</p>
        <p class="pactivetxt2">So that we can identify you</p>
      </li>
      <li class="success" [routerLink]="['/invest/phone-verification']">
        <p class="psuccesstxt">Mobile verification</p>
        <p class="pactivetxt2">To help us reach you</p>
      </li>
      <li class="success" [routerLink]="['/invest/email-verification']">
        <p class="psuccesstxt">Email verification</p>
        <p class="pactivetxt2">To help us reach you</p>
      </li>
      <li class="success" [routerLink]="['/lenderpersonalinfo']">
        <p class="psuccesstxt">Personal Information</p>
        <p class="pactivetxt2">It’s important for us to know you</p>
      </li>
      <li class="active">
        <p class="pactivetxt1">Proof of residence</p>
        <p class="pactivetxt2">To stay connected through a verified address</p>
      </li>
      <li>
        <p class="ptxt1">Bank details</p>
        <p class="ptxt2">To enable us send returns on your investment</p>
      </li>
      <li>
        <p class="ptxt1">Nominee Details</p>
        <p class="ptxt2">Add a nominee for your investments</p>
      </li>
      <li>
        <p class="ptxt1">Investment Preferences</p>
        <p class="ptxt2">Set your investment preferences to choose how your investments are allocated to loans</p>
      </li>
      <li>
        <p class="ptxt1">Upload Documents</p>
        <p class="ptxt2">To enable us to put your investments to work quicker</p>
      </li>
    </ul>
  </div>
</div>

<div class="leftinnerdiv" *ngIf="(lender_application_complete == 66) && (bank_details_filled == false)">
  <div class="row mainprogdiv">
    <ul class="progress2 vertical">
      <li class="success" [routerLink]="['/invest/pan-verification']">
        <p class="psuccesstxt">PAN verification</p>
        <p class="pactivetxt2">So that we can identify you</p>
      </li>
      <li class="success" [routerLink]="['/invest/phone-verification']">
        <p class="psuccesstxt">Mobile verification</p>
        <p class="pactivetxt2">To help us reach you</p>
      </li>
      <li class="success" [routerLink]="['/invest/email-verification']">
        <p class="psuccesstxt">Email verification</p>
        <p class="pactivetxt2">To help us reach you</p>
      </li>
      <li class="success" [routerLink]="['/lenderpersonalinfo']">
        <p class="psuccesstxt">Personal Information</p>
        <p class="pactivetxt2">It’s important for us to know you</p>
      </li>
      <li class="success" [routerLink]="['/invest/residence-info']">
        <p class="psuccesstxt">Proof of residence</p>
        <p class="pactivetxt2">To stay connected through a verified address</p>
      </li>
      <li class="active" [routerLink]="['/lenderbankdetails']">
        <p class="pactivetxt1">Bank details</p>
        <p class="pactivetxt2">To enable us send returns on your investment</p>
      </li>
      <li>
        <p class="ptxt1">Nominee Details</p>
        <p class="ptxt2">Add a nominee for your investments</p>
      </li>
      <li>
        <p class="ptxt1">Investment Preferences</p>
        <p class="ptxt2">Set your investment preferences to choose how your investments are allocated to loans</p>
      </li>
      <li>
        <p class="ptxt1">Upload Documents</p>
        <p class="ptxt2">To enable us to put your investments to work quicker</p>
      </li>
    </ul>
  </div>
</div>

<!--<div class="leftinnerdiv" *ngIf="(lender_application_complete == 66) && (bank_details_filled == true)">-->
<div class="leftinnerdiv" *ngIf="(lender_application_complete == 66) && (bank_details_filled === true) && (nominee_details_filled === false)">
    <div class="row mainprogdiv">
      <ul class="progress2 vertical">
        <li class="success" [routerLink]="['/invest/pan-verification']">
          <p class="psuccesstxt">PAN verification</p>
          <p class="pactivetxt2">So that we can identify you</p>
        </li>
        <li class="success" [routerLink]="['/invest/phone-verification']">
          <p class="psuccesstxt">Mobile verification</p>
          <p class="pactivetxt2">To help us reach you</p>
        </li>
        <li class="success" [routerLink]="['/invest/email-verification']">
          <p class="psuccesstxt">Email verification</p>
          <p class="pactivetxt2">To help us reach you</p>
        </li>
        <li class="success" [routerLink]="['/lenderpersonalinfo']">
          <p class="psuccesstxt">Personal Information</p>
          <p class="pactivetxt2">It’s important for us to know you</p>
        </li>
        <li class="success" [routerLink]="['/invest/residence-info']">
          <p class="psuccesstxt">Proof of residence</p>
          <p class="pactivetxt2">To stay connected through a verified address</p>
        </li>
        <li class="success" [routerLink]="['/lenderbankdetails']">
          <p class="psuccesstxt">Bank details</p>
          <p class="pactivetxt2">To enable us send returns on your investment</p>
        </li>
        <li class="active" [routerLink]="['/invest/lender-nominee']">
          <p class="pactivetxt1">Nominee Details</p>
          <p class="pactivetxt2">Add a nominee for your investments</p>
        </li>
        <li>
          <p class="ptxt1">Investment Preferences</p>
          <p class="ptxt2">Set your investment preferences to choose how your investments are allocated to loans</p>
        </li>
        <li>
          <p class="ptxt1">Upload Documents</p>
          <p class="ptxt2">To enable us to put your investments to work quicker</p>
        </li>
      </ul>
    </div>
  </div>

<div class="leftinnerdiv" *ngIf="(lender_application_complete == 66) && (bank_details_filled === true) && (nominee_details_filled === true) && (investment_preferences === false)">
    <div class="row mainprogdiv">
      <ul class="progress2 vertical">
        <li class="success" [routerLink]="['/invest/pan-verification']">
          <p class="psuccesstxt">PAN verification</p>
          <p class="pactivetxt2">So that we can identify you</p>
        </li>
        <li class="success" [routerLink]="['/invest/phone-verification']">
          <p class="psuccesstxt">Mobile verification</p>
          <p class="pactivetxt2">To help us reach you</p>
        </li>
        <li class="success" [routerLink]="['/invest/email-verification']">
          <p class="psuccesstxt">Email verification</p>
          <p class="pactivetxt2">To help us reach you</p>
        </li>
        <li class="success" [routerLink]="['/lenderpersonalinfo']">
          <p class="psuccesstxt">Personal Information</p>
          <p class="pactivetxt2">It’s important for us to know you</p>
        </li>
        <li class="success" [routerLink]="['/invest/residence-info']">
          <p class="psuccesstxt">Proof of residence</p>
          <p class="pactivetxt2">To stay connected through a verified address</p>
        </li>
        <li class="success" [routerLink]="['/lenderbankdetails']">
          <p class="psuccesstxt">Bank details</p>
          <p class="pactivetxt2">To enable us send returns on your investment</p>
        </li>
        <li class="success" [routerLink]="['/invest/lender-nominee']">
          <p class="psuccesstxt">Nominee Details</p>
          <p class="pactivetxt2">Add a nominee for your investments</p>
        </li>
        <li class="active" [routerLink]="['/invest/investment-preferences']">
          <p class="pactivetxt1">Investment Preferences</p>
          <p class="pactivetxt2">Set your investment preferences to choose how your investments are allocated to loans</p>
        </li>
        <li>
          <p class="ptxt1">Upload Documents</p>
          <p class="ptxt2">To enable us to put your investments to work quicker</p>
        </li>
      </ul>
    </div>
  </div>

<div class="leftinnerdiv" *ngIf="(lender_application_complete == 66) && (investment_preferences == true)">
    <div class="row mainprogdiv">
      <ul class="progress2 vertical">
        <li class="success" [routerLink]="['/invest/pan-verification']">
          <p class="psuccesstxt">PAN verification</p>
          <p class="pactivetxt2">So that we can identify you</p>
        </li>
        <li class="success" [routerLink]="['/invest/phone-verification']">
          <p class="psuccesstxt">Mobile verification</p>
          <p class="pactivetxt2">To help us reach you</p>
        </li>
        <li class="success" [routerLink]="['/invest/email-verification']">
          <p class="psuccesstxt">Email verification</p>
          <p class="pactivetxt2">To help us reach you</p>
        </li>
        <li class="success" [routerLink]="['/lenderpersonalinfo']">
          <p class="psuccesstxt">Personal Information</p>
          <p class="pactivetxt2">It’s important for us to know you</p>
        </li>
        <li class="success" [routerLink]="['/invest/residence-info']">
          <p class="psuccesstxt">Proof of residence</p>
          <p class="pactivetxt2">To stay connected through a verified address</p>
        </li>
        <li class="success" [routerLink]="['/lenderbankdetails']">
          <p class="psuccesstxt">Bank details</p>
          <p class="pactivetxt2">To enable us send returns on your investment</p>
        </li>
        <li class="success" [routerLink]="['/invest/lender-nominee']">
          <p class="psuccesstxt">Nominee Details</p>
          <p class="pactivetxt2">Add a nominee for your investments</p>
        </li>
        <li class="success" [routerLink]="['/invest/investment-preferences']">
          <p class="psuccesstxt">Investment Preferences</p>
          <p class="pactivetxt2">Set your investment preferences to choose how your investments are allocated to loans</p>
        </li>
        <li class="active" [routerLink]="['/lenderuploaddocuments']">
          <p class="pactivetxt1">Upload Documents</p>
          <p class="pactivetxt2">To enable us to put your investments to work quicker</p>
        </li>
      </ul>
    </div>
  </div>

<div class="leftinnerdiv" *ngIf="lender_application_complete == 100">
    <div class="row mainprogdiv">
      <ul class="progress2 vertical">
        <li class="success" [routerLink]="['/invest/pan-verification']">
          <p class="psuccesstxt">PAN verification</p>
          <p class="pactivetxt2">So that we can identify you</p>
        </li>
        <li class="success" [routerLink]="['/invest/phone-verification']">
          <p class="psuccesstxt">Mobile verification</p>
          <p class="pactivetxt2">To help us reach you</p>
        </li>
        <li class="success" [routerLink]="['/invest/email-verification']">
          <p class="psuccesstxt"> Email verification</p>
          <p class="pactivetxt2">To help us reach you</p>
        </li>
        <li class="success" [routerLink]="['/lenderpersonalinfo']">
          <p class="psuccesstxt">Personal Information</p>
          <p class="pactivetxt2">It’s important for us to know you</p>
        </li>
        <li class="success" [routerLink]="['/invest/residence-info']">
          <p class="psuccesstxt">Proof of residence</p>
          <p class="pactivetxt2">To stay connected through a verified address</p>
        </li>
        <li class="success" [routerLink]="['/lenderbankdetails']">
          <p class="psuccesstxt">Bank details</p>
          <p class="pactivetxt2">To enable us send returns on your investment</p>
        </li>
        <li class="success" [routerLink]="['/invest/lender-nominee']">
          <p class="psuccesstxt">Nominee Details</p>
          <p class="pactivetxt2">Add a nominee for your investments</p>
        </li>
        <li class="success" [routerLink]="['/invest/investment-preferences']">
          <p class="psuccesstxt">Investment Preferences</p>
          <p class="pactivetxt2">Set your investment preferences to choose how your investments are allocated to loans</p>
        </li>
        <li class="success" [routerLink]="['/lenderuploaddocuments']">
          <p class="psuccesstxt">Upload Documents</p>
          <p class="pactivetxt2">To enable us to put your investments to work quicker</p>
        </li>
      </ul>
    </div>
  </div>

<div class="leftinnerdiv" *ngIf="lender_application == 1">
    <div class="row mainprogdiv">
      <ul class="progress2 vertical">
        <li class="active">
          <p class="pactivetxt1">PAN verification</p>
          <p class="pactivetxt2">So that we can identify you</p>
        </li>
        <li>
          <p class="ptxt1">Mobile verification</p>
          <p class="ptxt2">To help us reach you</p>
        </li>
        <li>
          <p class="ptxt1"> Email verification</p>
          <p class="ptxt2">To help us reach you</p>
        </li>
        <li>
          <p class="ptxt1">Personal Information</p>
          <p class="ptxt2">It’s important for us to know you</p>
        </li>
        <li>
          <p class="ptxt1">Proof of residence</p>
          <p class="ptxt2">To stay connected through a verified address</p>
        </li>
        <li>
          <p class="ptxt1">Bank details</p>
          <p class="ptxt2">To enable us send returns on your investment</p>
        </li>
        <li>
          <p class="ptxt1">Nominee Details</p>
          <p class="ptxt2">Add a nominee for your investments</p>
        </li>
        <li>
          <p class="ptxt1">Investment Preferences</p>
          <p class="ptxt2">Set your investment preferences to choose how your investments are allocated to loans</p>
        </li>
        <li>
          <p class="ptxt1">Upload Documents</p>
          <p class="ptxt2">To enable us to put your investments to work quicker</p>
        </li>
      </ul>
    </div>
  </div>

<div class="leftinnerdiv" *ngIf="lender_application == 2">
    <div class="row mainprogdiv">
      <ul class="progress2 vertical">
        <li class="success" [routerLink]="['/invest/pan-verification']">
          <p class="psuccesstxt">PAN verification</p>
          <p class="pactivetxt2">So that we can identify you</p>
        </li>
        <li class="active">
          <p class="pactivetxt1">Mobile verification</p>
          <p class="pactivetxt2">To help us reach you</p>
        </li>
        <li>
          <p class="ptxt1"> Email verification</p>
          <p class="ptxt2">To help us reach you</p>
        </li>
        <li>
          <p class="ptxt1">Personal Information</p>
          <p class="ptxt2">It’s important for us to know you</p>
        </li>
        <li>
          <p class="ptxt1">Proof of residence</p>
          <p class="ptxt2">To stay connected through a verified address</p>
        </li>
        <li>
          <p class="ptxt1">Bank details</p>
          <p class="ptxt2">To enable us send returns on your investment</p>
        </li>
        <li>
          <p class="ptxt1">Nominee Details</p>
          <p class="ptxt2">Add a nominee for your investments</p>
        </li>
        <li>
          <p class="ptxt1">Investment Preferences</p>
          <p class="ptxt2">Set your investment preferences to choose how your investments are allocated to loans</p>
        </li>
        <li>
          <p class="ptxt1">Upload Documents</p>
          <p class="ptxt2">To enable us to put your investments to work quicker</p>
        </li>
      </ul>
    </div>
  </div>

<div class="leftinnerdiv" *ngIf="lender_application == 3">
  <div class="row mainprogdiv">
      <ul class="progress2 vertical">
        <li class="success" [routerLink]="['/invest/pan-verification']">
          <p class="psuccesstxt">PAN verification</p>
          <p class="pactivetxt2">So that we can identify you</p>
        </li>
        <li class="success" [routerLink]="['/invest/phone-verification']">
          <p class="psuccesstxt">Mobile verification</p>
          <p class="pactivetxt2">To help us reach you</p>
        </li>
        <li class="active">
          <p class="pactivetxt1">Email verification</p>
          <p class="pactivetxt2">To help us reach you</p>
        </li>
        <li>
          <p class="ptxt1">Personal Information</p>
          <p class="ptxt2">It’s important for us to know you</p>
        </li>
        <li>
          <p class="ptxt1">Proof of residence</p>
          <p class="ptxt2">To stay connected through a verified address</p>
        </li>
        <li>
          <p class="ptxt1">Bank details</p>
          <p class="ptxt2">To enable us send returns on your investment</p>
        </li>
        <li>
          <p class="ptxt1">Nominee Details</p>
          <p class="ptxt2">Add a nominee for your investments</p>
        </li>
        <li>
          <p class="ptxt1">Investment Preferences</p>
          <p class="ptxt2">Set your investment preferences to choose how your investments are allocated to loans</p>
        </li>
        <li>
          <p class="ptxt1">Upload Documents</p>
          <p class="ptxt2">To enable us to put your investments to work quicker</p>
        </li>
      </ul>
    </div>
  </div>
